function initDetailLogic() {}
export default { initDetailLogic }
